import {combineReducers, createStore} from 'redux';
import {task} from "../Reducer/task";
import {account} from "../Reducer/account";

const rootReducer = combineReducers({
    task,
    account
});

export const store = createStore(rootReducer);
